import Container from '@/components/Container';
import useIsTablet from '@/hooks/useIsTablet';

export const ResourceHubListLoading = () => {
  const { isTablet } = useIsTablet();

  return (
    <>
      <div className="w-full bg-light-green py-sh-60">
        <Container>
          <div className="col-span-12">
            <div className="my-[12px]">
              <div className="h-8 w-48 animate-pulse rounded bg-gray-200" />
            </div>
            <div className="mt-2 h-4 w-full max-w-xl animate-pulse rounded bg-gray-200" />
          </div>
        </Container>
      </div>
      <Container className="min-h-40" addMargin={!isTablet}>
        <div className="col-span-12 mt-[30px] md:mt-[0px]">
          <div className="mb-sh-30">
            <div className="h-12 w-full rounded bg-gray-200" />
          </div>

          <div className="mb-sh-30 flex gap-4">
            <div className="h-10 w-24 rounded-full bg-gray-200" />
            <div className="h-10 w-24 rounded-full bg-gray-200" />
            <div className="h-10 w-24 rounded-full bg-gray-200" />
            <div className="h-10 w-24 rounded-full bg-gray-200" />
          </div>

          <div className="grid grid-cols-1 gap-sh-30 md:grid-cols-2 lg:grid-cols-3">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="animate-pulse rounded-sh-16 border border-gray-200 p-4">
                <div className="mb-4 h-6 w-3/4 rounded bg-gray-200" />
                <div className="mb-2 h-4 w-full rounded bg-gray-200" />
                <div className="mb-4 h-4 w-2/3 rounded bg-gray-200" />
                <div className="flex gap-2">
                  <div className="h-6 w-16 rounded-full bg-gray-200" />
                  <div className="h-6 w-16 rounded-full bg-gray-200" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </>
  );
};
